import { Theme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";
import { StyleSheet } from "@react-pdf/renderer";

import VoTheme from "ui/theme/vocollege2";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flex: 1,
      flexDirection: "column",

      // alignItems: "stretch",
      // display: "flex",
      // flex: 1,
      // font: "16px/20px Garamond",
      // maxWidth: "100%",
      // padding: theme.spacing(4),
    },
    // wrapper: {
    //   border: `3px solid ${theme.palette.primary.main}`,
    //   borderRadius: theme.shape.borderRadiusBig,
    //   flex: 1,
    //   maxWidth: "100%",
    //   paddingTop: "10%",
    //   position: "relative",
    //   textAlign: "center",
    // },
    // // logo: {
    // //   marginLeft: "auto",
    // //   marginRight: "auto",
    // //   width: "17%",
    // // },
    // // logoPlaceholder: {
    // //   alignItems: "center",
    // //   border: `1px solid ${theme.palette.grey[100]}`,
    // //   display: "flex",
    // //   flexDirection: "column",
    // //   height: "22%",
    // //   justifyContent: "center",
    // //   marginLeft: "auto",
    // //   marginRight: "auto",
    // //   padding: theme.spacing(1),
    // //   width: "22%",
    // // },
    // // logoPlaceholderTitle: {},
    // // logoPlaceholderSubtitle: {
    // //   lineHeight: "1.2em",
    // // },
    // title: {},
    // name: {},
    // personalNumber: {},
    // row: {},
    // signatures: {
    //   display: "flex",
    //   marginLeft: "auto",
    //   marginRight: "auto",
    //   width: "70%",
    // },
    // signature: {
    //   borderTop: `1px solid ${theme.palette.common.black}`,
    //   flex: 1,
    //   fontSize: "60%",
    //   lineHeight: "1.3em",
    //   marginLeft: "2%",
    //   marginRight: "2%",
    // },
    // signaturePerson: {},
    // signatureTitle: {},
    // certifiedSince: {
    //   fontSize: "60%",
    //   fontStyle: "italic",
    // },
    // footer: {
    //   border: "1px solid red",
    //   bottom: 0,
    //   left: 0,
    //   position: "absolute",
    //   right: 0,
    // },
  })
);

export const styles = StyleSheet.create({
  page: {
    fontFamily: "EB Garamond",
    padding: VoTheme.spacing(4),
  },
  decor: {
    border: `5px solid ${VoTheme.palette.primary.main}`,
    borderTopLeftRadius: VoTheme.shape.borderRadiusBig,
    borderTopRightRadius: VoTheme.shape.borderRadiusBig,
    borderBottomRightRadius: VoTheme.shape.borderRadiusBig,
    borderBottomLeftRadius: VoTheme.shape.borderRadiusBig,
    height: "100%",
    width: "100%",
  },
  logoWrapper: {
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    marginTop: VoTheme.spacing(6),
  },
  title: {
    color: VoTheme.palette.grey[500],
    fontSize: 32,
    fontWeight: 700,
    textAlign: "center",
    textTransform: "uppercase",
  },
  person: {
    fontFamily: "Times-Italic",
    fontSize: 24,
    fontWeight: 500,
    textAlign: "center",
  },
  personalNumber: {
    fontFamily: "Times-Roman",
    fontSize: 12,
    textAlign: "center",
  },
  text: {
    fontSize: 12,
    textAlign: "center",
  },
  footer: {
    fontSize: 10,
    marginBottom: VoTheme.spacing(2),
    textAlign: "center",
  },
  signatures: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    paddingLeft: VoTheme.spacing(7),
    paddingRight: VoTheme.spacing(7),
    width: "100%",
  },
  signature: {
    borderTop: `1px solid ${VoTheme.palette.common.black}`,
    flex: 1,
    marginLeft: VoTheme.spacing(1),
    marginRight: VoTheme.spacing(1),
    maxWidth: 250,
  },
  signaturePerson: {},
  signatureTitle: {},
  educatorCertified: {
    marginTop: VoTheme.spacing(4),
  },
  uid: {
    bottom: 2,
    position: "absolute",
    right: VoTheme.spacing(4),
  },
});
